import { useQuery } from "@tanstack/react-query";
import { getJobsById } from "../../../../../utils";
import { JobById } from "../../../interfaces/job-by-id.interfaces";

interface Props {
  idStr: string | number;
  token?: string | null;
}

export function useJobsByIdQuery({ idStr, token }: Props) {
  const localToken = sessionStorage.getItem("token");

  const effectiveToken = token ?? localToken;

  return useQuery<JobById>({
    queryKey: ["job", idStr],
    queryFn: async () => {
      if (!effectiveToken) {
        throw new Error("Missing auth token");
      }

      const res = await getJobsById({
        token: effectiveToken,
        id: idStr,
      });

      return res?.data;
    },
    enabled: Boolean(idStr && effectiveToken),
    refetchOnWindowFocus: false,
  });
}
